import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/utils/api'

export const useWishlistStore = defineStore('wishlist', () => {
  const items = ref(JSON.parse(localStorage.getItem('wishlist_items')) || [])
  const loading = ref(false)

  const itemCount = computed(() => items.value.length)

  function isWishlisted(productId) {
    return items.value.some(item => item.product_id === productId)
  }

  async function fetchWishlist() {
    loading.value = true
    try {
      const response = await api.get('/wishlist')
      // Extract array from paginated response
      items.value = response.data.data?.data || response.data.data || []
      localStorage.setItem('wishlist_items', JSON.stringify(items.value))
    } catch (error) {
      console.error('Failed to fetch wishlist:', error)
    } finally {
      loading.value = false
    }
  }

  async function toggleWishlist(productId) {
    const exists = isWishlisted(productId)

    // Optimistic UI update
    if (exists) {
      items.value = items.value.filter(item => item.product_id !== productId)
    } else {
      items.value.push({ product_id: productId })
    }

    try {
      if (exists) {
        await api.delete(`/wishlist/${productId}`)
      } else {
        await api.post('/wishlist', { product_id: productId })
      }
      // Re-sync with backend to ensure data consistency
      await fetchWishlist()
      return { success: true, added: !exists }
    } catch (error) {
      // Revert optimistic update on failure
      await fetchWishlist()
      return { success: false, error: error.response?.data?.message || 'Action failed' }
    }
  }

  async function clearWishlistLocal() {
    items.value = []
    localStorage.removeItem('wishlist_items')
  }

  return {
    items,
    loading,
    itemCount,
    isWishlisted,
    fetchWishlist,
    toggleWishlist,
    clearWishlistLocal
  }
})
